"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _urlJoin = _interopRequireDefault(require("url-join"));

var _siteConfig = require("@immediate_media/site-config");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * Get the filters to be used for one of the list endpoints.
 */
var getFilters = function getFilters(filters, siteKey, appendClient, appendLanguage) {
  var obj = Object.keys(filters).filter(function (filter) {
    return filter;
  }) // Remove undefined
  .reduce(function (acc, filter) {
    acc[filter] = filters[filter];
    return acc;
  }, {}); // The search API currently uses `sitekey` instead of `client`. The if
  // statement can go once that API is made consistent

  if (!obj.sitekey) {
    obj.client = siteKey; // Add client filter to all requests
  } // Due to constraints on the V4 and V5 search api we are ensuring search param
  // is trimmed to 250 characters this ensures that we do not receive a
  // bad response when validated by the api the API Limit is 280


  if ((obj === null || obj === void 0 ? void 0 : obj.search) && (obj === null || obj === void 0 ? void 0 : obj.search.length) > 250) {
    var searchTermTrimmedToMaxLength = obj.search.substring(0, 250);
    var searchTermTrimmedToLastWord = searchTermTrimmedToMaxLength.substr(0, Math.min(searchTermTrimmedToMaxLength.length, searchTermTrimmedToMaxLength.lastIndexOf(' ')));
    obj.search = searchTermTrimmedToLastWord;
  }

  if (appendClient) {
    delete obj.sitekey;
  }

  if (appendLanguage) {
    var _sites$siteKey$langua = _siteConfig.sites[siteKey].language,
        language = _sites$siteKey$langua === void 0 ? 'en' : _sites$siteKey$langua;

    var _language$split = language.split('-'),
        _language$split2 = _slicedToArray(_language$split, 1),
        lang = _language$split2[0];

    obj.lang = lang;
  }

  return obj;
}; // V5 of search requires that the client is appended to the endpoint path


var getEndpoint = function getEndpoint(endpoint, siteKey, appendClient) {
  if (appendClient) {
    return (0, _urlJoin["default"])(endpoint, siteKey);
  }

  return endpoint;
};
/**
 * Register the functions for each API endpoint.
 */


var _default = function _default(client, siteKey, _ref, appendClientToEndpoint, appendLanguage) {
  var endpoint = _ref.endpoint,
      mocks = _ref.mocks;
  var functions = {
    get: function get(id) {
      if (!id) {
        throw new TypeError('An id must be given for the entity to get, perhaps you want the filter() function.');
      }

      return client.get((0, _urlJoin["default"])(endpoint, id.toString()));
    },
    create: function create(data) {
      if (!data) {
        throw new TypeError('Some data must be given to create an entity.');
      }

      return client.post(endpoint, {
        data: data
      });
    },
    "delete": function _delete(id) {
      if (!id) {
        throw new TypeError('An id must be given for the entity to delete.');
      }

      return client["delete"]((0, _urlJoin["default"])(endpoint, id.toString()));
    },
    update: function update(id, data) {
      if (!id) {
        throw new TypeError('An id must be given for the entity to update.');
      }

      if (!data) {
        throw new TypeError('Some data must be given to update an entity.');
      }

      return client.put((0, _urlJoin["default"])(endpoint, id.toString()), {
        data: data
      });
    },
    filter: function filter() {
      var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return client.get(getEndpoint(endpoint, siteKey, appendClientToEndpoint), {
        params: getFilters(filters, siteKey, appendClientToEndpoint, appendLanguage)
      });
    },
    find: function () {
      var _find = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _data$hydraMember;

        var filters,
            data,
            _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                filters = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
                _context.next = 3;
                return client.get(getEndpoint(endpoint, siteKey, appendClientToEndpoint), {
                  params: getFilters(_objectSpread(_objectSpread({}, filters), {}, {
                    limit: 1
                  }), siteKey, appendClientToEndpoint, appendLanguage)
                });

              case 3:
                data = _context.sent;
                return _context.abrupt("return", data === null || data === void 0 ? void 0 : (_data$hydraMember = data['hydra:member']) === null || _data$hydraMember === void 0 ? void 0 : _data$hydraMember[0]);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function find() {
        return _find.apply(this, arguments);
      }

      return find;
    }()
  }; // Replace any mocked functions

  if (mocks) {
    var mockFunctions = mocks(_objectSpread({}, functions));
    Object.keys(mockFunctions).forEach(function (functionName) {
      functions[functionName] = mockFunctions[functionName];
    });
  }

  return functions;
};

exports["default"] = _default;